import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import userPreviewIcon from "assets/images/svg/userPreview.svg";
import BackButtonLink from "components/Common/buttons/BackButtonLink";
import calendarIcon from "assets/images/svg/calendarMinus.svg";
import moment from "moment/moment";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 15,
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: 8,

    "& span": {
      fontSize: 16,
      fontWeight: 600,
      marginBottom: 4,
    },
  },
  iconContainer: {
    padding: 8,
    marginLeft: 23,
    borderRadius: "50%",
    backgroundColor: "#ebebeb",
    width: 65,
    minWidth: 65,
    height: 65,

    "& img": {
      width: "100%",
      height: "100%",
      backgroundColor: "#D9D9D9",
      borderRadius: "50%",
    },
  },
  rightContainer: {
    display: "flex",
    marginTop: 15,
  },
  mainInfo: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 8px 16px 0 #00000014",
    borderRadius: 100,
    height: 60,
  },
  section: {
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    width: 180,

    "&>img": {
      width: 30,
      marginRight: 10,
    },
  },
  title: {
    color: "#666666",
    fontSize: 9,
    fontWeight: 300,
    textTransform: "uppercase ",
  },
  data: {
    fontSize: 11,
    fontWeight: 600,
  },
});

const Header = ({ acquisitionDate }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <BackButtonLink to={"/operations/prospects"}>Back</BackButtonLink>

        <div className={classes.iconContainer}>
          <img src={userPreviewIcon} alt="customer" />
        </div>
        <div className={classes.nameContainer}>
          <span>NEW PROSPECT</span>
        </div>
      </div>

      {acquisitionDate?.availableAt && (
        <div className={classes.rightContainer}>
          <div className={classes.mainInfo}>
            <div className={classes.section}>
              <img src={calendarIcon} alt="Acquisition Date" />
              <div>
                <div className={classes.title}>Acquisition Date</div>
                <div className={classes.data}>
                  {moment(acquisitionDate?.availableAt).format("DD MMM")} - {acquisitionDate?.timeSlot}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
